import { Address } from '@ui/types/alias';
import { create } from 'zustand';

interface ClosingPositionsStore {
  closingPositionIds: ClosingPosition[];
  addClosingPosition: (id: Address, positionTimestamp?: number) => void;
  removeClosedPosition: (id: Address, positionTimestamp?: number) => void;
}

export type ClosingPosition = {
  id: Address;
  positionTimestamp?: number;
};

export const useClosingPositionsStore = create<ClosingPositionsStore>()(
  (set) => ({
    closingPositionIds: [],
    addClosingPosition: (id: Address, positionTimestamp?: number) =>
      set((state) => {
        if (
          state.closingPositionIds.some(
            (position) =>
              position.id === id &&
              position.positionTimestamp === positionTimestamp,
          )
        ) {
          return state;
        }

        return {
          closingPositionIds: [
            ...state.closingPositionIds,
            {
              id,
              positionTimestamp,
            },
          ],
        };
      }),
    removeClosedPosition: (id: Address, positionTimestamp?: number) =>
      set((state) => ({
        closingPositionIds: state.closingPositionIds.filter(
          (position) =>
            position.id !== id ||
            (positionTimestamp !== undefined &&
              position.positionTimestamp !== positionTimestamp),
        ),
      })),
  }),
);
